import { AppState } from 'src/store';
import { createSelector } from 'reselect';
import { get } from 'lodash';
import { projectState, StateSelection } from 'src/components/ListGridPair/ListGridPair.selectors';
import { STYLE_COLOR_NAME } from 'src/utils/Domain/Constants';
import { getDataFromCache, isDataLoaded } from 'src/services/pivotServiceCache';
import { AdornmentType } from 'configuration-schemas/viewdefns/literals';
import type { HistoryGridOwnProps } from 'configuration-schemas/ownProps';

function selectState(state: AppState, ownProps: HistoryGridOwnProps): StateSelection {
  const { title, defns, showFlowStatus } = ownProps;
  const { listView: viewState } = state.pages.hindsighting.historyGrid;

  const { viewDataState, viewDefns, isConfigLoading } = viewState;
  const treeData = getDataFromCache(viewState)?.tree || [];
  const configLoaded = !viewState.isConfigLoading;
  const dataLoaded = isDataLoaded(viewDataState);
  const adornments: AdornmentType[] = get(viewState.viewDefns.grid, 'adornments', []);

  return {
    identityField: ownProps.keys?.idProp || STYLE_COLOR_NAME,
    subheaderState: state.subheader,
    configLoaded,
    dataLoaded,
    treeData,
    title,
    subheaderViewDefns: defns.subheader,
    shouldFilterFlowStatus: false,
    activeTab: state.perspective.activeTab,
    viewDefns,
    isConfigLoading,
    viewDataState,
    adornments,
    allowWorklistFunctionality: false,
    showFlowStatus,
    isCompanionCollapsed: state.uiPose.isCompanionCollapsed,
  };
}

export const selectData = createSelector(selectState, projectState);
